import { Variants as u } from "./atoms-v2786.js";
import { ColorThemes as p } from "./atoms-v21024.js";
const $ = ({
  colorTheme: d,
  isIconOnly: g = !1,
  isSkeleton: r,
  isTextOnly: s = !1,
  shape: a,
  size: k,
  theme: o,
  variant: x
}) => {
  const i = d === p.dark, l = g ? "1/1" : "auto", n = () => {
    if (r && d === p.light)
      return o == null ? void 0 : o.get("ui.button.primary.light.skeleton");
    if (r && d === p.dark)
      return o == null ? void 0 : o.get("ui.button.primary.dark.skeleton");
  }, b = () => r ? 0 : a === "square" ? o == null ? void 0 : o.get("tokens.radius.buttonSmallRounded") : o == null ? void 0 : o.get("tokens.radius.buttonFullRounded"), c = () => {
    if (r)
      return "none";
  }, t = () => g ? 0 : k === "small" ? "4px 12px" : "10px 18px";
  return {
    [u.text]: {
      color: o == null ? void 0 : o.get("tokens.text.light.primary"),
      fontSize: "inherit",
      textDecoration: "underline",
      textDecorationThickness: "1px",
      textUnderlineOffset: "0.2em",
      "&:hover": {
        color: o == null ? void 0 : o.get("tokens.text.light.primary")
      },
      "&[disabled]": {
        color: i ? o == null ? void 0 : o.get("tokens.text.dark.disabled") : o == null ? void 0 : o.get("tokens.text.light.disabled")
      },
      "&:focus-visible": {
        outline: c() || (i ? `1px solid ${o == null ? void 0 : o.get("ui.button.primary.dark.focus")}` : `1px solid ${o == null ? void 0 : o.get("ui.button.primary.light.focus")}`),
        outlineOffset: "2px"
      }
    },
    [u.ghost]: {
      aspectRatio: l,
      backgroundColor: n() || "transparent",
      borderRadius: b(),
      color: i ? o == null ? void 0 : o.get("ui.button.ghost.dark.text") : o == null ? void 0 : o.get("ui.button.ghost.light.text"),
      padding: t(),
      textDecoration: s ? "underline" : "none",
      textUnderlineOffset: "3px",
      WebkitFontSmoothing: i ? "antialiased" : "subpixel-antialiased",
      "&:hover": {
        backgroundColor: n() || (i ? o == null ? void 0 : o.get("ui.button.ghost.dark.hover") : o == null ? void 0 : o.get("ui.button.ghost.light.hover")),
        textDecoration: "none"
      },
      "&:active": {
        backgroundColor: n() || (i ? o == null ? void 0 : o.get("ui.button.ghost.dark.active") : o == null ? void 0 : o.get("ui.button.ghost.light.active")),
        textDecoration: "none"
      },
      "&[disabled]": {
        backgroundColor: n() || "transparent",
        color: i ? o == null ? void 0 : o.get("ui.button.ghost.dark.disabled") : o == null ? void 0 : o.get("ui.button.ghost.light.disabled")
      },
      "&:focus-visible": {
        backgroundColor: n() || "transparent",
        outline: c() || (i ? `1px solid ${o == null ? void 0 : o.get("ui.button.ghost.dark.focus")}` : `1px solid ${o == null ? void 0 : o.get("ui.button.ghost.light.focus")}`),
        outlineOffset: "-1px"
      }
    },
    [u.primary]: {
      aspectRatio: l,
      backgroundColor: n() || (i ? o == null ? void 0 : o.get("ui.button.primary.dark.bkg") : o == null ? void 0 : o.get("ui.button.primary.light.bkg")),
      borderRadius: b(),
      color: i ? o == null ? void 0 : o.get("ui.button.primary.dark.text") : o == null ? void 0 : o.get("ui.button.primary.light.text"),
      WebkitFontSmoothing: i ? "subpixel-antialiased" : "antialiased",
      padding: t(),
      "&:hover": {
        background: n() || (i ? `linear-gradient(0deg, ${o == null ? void 0 : o.get("ui.button.primary.dark.hover")} 0%, ${o == null ? void 0 : o.get(
          "ui.button.primary.dark.hover"
        )} 100%), ${o == null ? void 0 : o.get("ui.button.primary.dark.bkg")}` : `linear-gradient(0deg, ${o == null ? void 0 : o.get("ui.button.primary.light.hover")} 0%, ${o == null ? void 0 : o.get(
          "ui.button.primary.light.hover"
        )} 100%), ${o == null ? void 0 : o.get("ui.button.primary.light.bkg")}`)
      },
      "&:active": {
        background: n() || (i ? `linear-gradient(0deg, ${o == null ? void 0 : o.get("ui.button.primary.dark.active")} 0%, ${o == null ? void 0 : o.get(
          "ui.button.primary.dark.active"
        )} 100%), ${o == null ? void 0 : o.get("ui.button.primary.dark.bkg")}` : `linear-gradient(0deg, ${o == null ? void 0 : o.get("ui.button.primary.light.active")} 0%, ${o == null ? void 0 : o.get(
          "ui.button.primary.light.active"
        )} 100%), ${o == null ? void 0 : o.get("ui.button.primary.light.bkg")}`)
      },
      "&[disabled]": {
        backgroundColor: n() || (i ? o == null ? void 0 : o.get("ui.button.primary.dark.disabled") : o == null ? void 0 : o.get("ui.button.primary.light.disabled")),
        color: i ? o == null ? void 0 : o.get("ui.button.primary.dark.disabledText") : o == null ? void 0 : o.get("ui.button.primary.light.disabledText"),
        WebkitFontSmoothing: "subpixel-antialiased"
      },
      "&:focus-visible": {
        outline: i ? `1px solid ${o == null ? void 0 : o.get("ui.button.primary.dark.focus")}` : `1px solid ${o == null ? void 0 : o.get("ui.button.primary.light.focus")}`,
        outlineOffset: "-3px"
      }
    },
    [u.secondary]: {
      aspectRatio: l,
      backgroundColor: n() || "transparent",
      borderRadius: b(),
      color: i ? o == null ? void 0 : o.get("ui.button.secondary.dark.text") : o == null ? void 0 : o.get("ui.button.secondary.light.text"),
      outline: c() || (i ? `1px solid ${o == null ? void 0 : o.get("ui.button.secondary.dark.focus")}` : `1px solid ${o == null ? void 0 : o.get("ui.button.secondary.light.focus")}`),
      padding: t(),
      WebkitFontSmoothing: i ? "antialiased" : "subpixel-antialiased",
      "&:hover": {
        backgroundColor: n() || (i ? o == null ? void 0 : o.get("ui.button.secondary.dark.hover") : o == null ? void 0 : o.get("ui.button.secondary.light.hover")),
        color: i ? o == null ? void 0 : o.get("ui.button.secondary.dark.text") : o == null ? void 0 : o.get("ui.button.secondary.light.text"),
        WebkitFontSmoothing: "antialiased"
      },
      "&:active": {
        backgroundColor: n() || (i ? o == null ? void 0 : o.get("ui.button.secondary.dark.active") : o == null ? void 0 : o.get("ui.button.secondary.light.active")),
        color: i ? o == null ? void 0 : o.get("ui.button.secondary.dark.text") : o == null ? void 0 : o.get("ui.button.secondary.light.text"),
        WebkitFontSmoothing: i ? "subpixel-antialiased" : "antialiased"
      },
      "&[disabled]": {
        backgroundColor: n() || "transparent",
        color: i ? o == null ? void 0 : o.get("ui.button.secondary.dark.disabledText") : o == null ? void 0 : o.get("ui.button.secondary.light.disabledText"),
        outlineColor: i ? o == null ? void 0 : o.get("ui.button.secondary.dark.disabledText") : o == null ? void 0 : o.get("ui.button.secondary.light.disabledText")
      },
      "&:focus-visible": {
        backgroundColor: n() || "transparent",
        border: `1px solid ${i ? o == null ? void 0 : o.get("ui.button.secondary.dark.focus") : o == null ? void 0 : o.get("ui.button.secondary.light.focus")}`,
        color: i ? o == null ? void 0 : o.get("ui.button.secondary.dark.text") : o == null ? void 0 : o.get("ui.button.secondary.light.text"),
        outlineColor: i ? o == null ? void 0 : o.get("ui.button.secondary.dark.focus") : o == null ? void 0 : o.get("ui.button.secondary.light.focus"),
        outlineOffset: "-3px",
        WebkitFontSmoothing: i ? "subpixel-antialiased" : "antialiased"
      }
    }
  }[x];
}, C = ({
  isSkeleton: d,
  size: g,
  theme: r,
  variant: s
}) => {
  if (s !== u.text)
    switch (g) {
      case "small": {
        const a = r == null ? void 0 : r.get("tokens.body.expressive");
        return {
          ...a && a.toJS(),
          minHeight: d && s === u.ghost ? "16px" : "32px"
        };
      }
      case "expressive": {
        const a = r == null ? void 0 : r.get("tokens.body.expressive");
        return {
          ...a && a.toJS(),
          minHeight: d && s === u.ghost ? "16px" : "44px"
        };
      }
      case "medium":
      default: {
        const a = r == null ? void 0 : r.get("tokens.body.compact-productive");
        return {
          ...a && a.toJS(),
          minHeight: d && s === u.ghost ? "16px" : "44px"
        };
      }
    }
};
export {
  C as getSize,
  $ as getStyles
};
